<template>
  <ZDialog :show="isVisible" :modal-size="modalSize">
    <template #header>
      <div class="custom-header">
        <div class="row">
          <div class="col-md-11">
            <h4 class="modal-title">Add New ADAS Inspection</h4>
          </div>
          <div class="col-md-1">
            <a href="#" class="custom-close" @click.prevent="close">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </div>
    </template>
    <template #body>
      <OverviewForm :is-from-listing="true" @open="open" @created="isCreated = true" />
    </template>
  </ZDialog>
</template>
<script>
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import OverviewForm from './OverviewForm.vue'
// #668: Repairs list "Add", same VIN overview flow as ADAS Map's dialog-add.
export default {
  name: 'DialogAddInspection',
  components: {
    ZDialog,
    OverviewForm
  },
  props: {
    modelValue: Object
  },
  emits: ['closing', 'open'],
  data() {
    return {
      modalSize: 'modal-lg',
      isCreated: false
    }
  },
  computed: {
    isVisible() {
      return this.modelValue !== null && this.modelValue !== undefined
    }
  },
  methods: {
    close() {
      this.$emit('closing', this.isCreated)
      this.isCreated = false
    },
    open(data) {
      this.isCreated = false
      this.$emit('open', data)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}
</style>
